module.exports = __webpack_public_path__ + "img/quayRampTram.0584a683.svg";